// import { useState, useEffect } from "react";
// import { yupResolver } from "@hookform/resolvers/yup";
// import { useMutation, useQuery } from "@tanstack/react-query";
// import { toast } from "react-toastify";
// import { useForm, Controller } from "react-hook-form";
// import ReactQuill from "react-quill";
// import Label from "../../ChildComponents/Label";
// // child
// import Input from "../../ChildComponents/Input";
// import BrandButton from "../../ChildComponents/BrandButton";
// import ImageUpload from "../../ChildComponents/ImageUpload";
// import Select from "../../ChildComponents/Select";

// // validationSchema
// import { Rolechema } from "../validation/roleValidation";

// // api
// import { useGetCategory } from "../../store/api/categoryApi";

// import { useCreateTopic, useUpdateTopic } from "../../store/api/topicApi";

// function TopicForm({ data, editId, onSuccessCreated }) {
//   const updateTopic = useUpdateTopic(editId?._id);
//   // init
//   const {
//     register,
//     handleSubmit,
//     formState: { errors },
//     reset,
//     control,
//     watch,
//   } = useForm({
//     resolver: yupResolver(Rolechema),
//   });

//   const getCategory = useGetCategory();
//   const {
//     data: categoryData,
//     isLoading: isRoleLoading,
//     error: roleError,
//   } = useQuery({ queryKey: "category", queryFn: getCategory });

//   const transformedCategory = categoryData?.categorys?.map((i) => ({
//     label: i.name,
//     value: i._id,
//   }));

//   useEffect(() => {
//     if (editId) {
//       reset({
//         name: editId?.name || "",
//         topicSlug: editId?.topicSlug || "",
//         details: editId?.details || "",
//         parentCategory:
//           editId?.parentCategory?.map((cat) => ({
//             label: cat?.name,
//             value: cat?._id,
//           })) || [],
//       });
//       setEdited(true);
//     }
//   }, [editId, reset]);

//   const createTopic = useCreateTopic();

//   const [loading, setLoading] = useState(false);
//   const [edited, setEdited] = useState(editId ? true : false);

//   const mutation = useMutation({
//     mutationFn: (data) => {
//       return editId ? updateTopic(data) : createTopic(data);
//     },
//     onSuccess: (data) => {
//       setLoading(false);
//       toast.success("Creatred Successfuly");
//       reset();
//       onSuccessCreated(1);
//     },
//     onError: (error) => {
//       toast.error(error.message);
//       setLoading(false);
//     },
//   });

//   const onSubmit = (formData) => {
//     setLoading(true);
//     try {
//       mutation.mutate({
//         name: formData?.name,
//         topicSlug: formData?.topicSlug,
//         details: formData?.details,
//         parentCategory:
//           formData?.parentCategory?.map((item) => item.value) || [],
//       });
//     } catch (error) {
//       setLoading(false);
//       console.error("Caught error in handleSubmit:", error.message);
//       toast.error(error.message);
//     }
//   };

//   return (
//     <div>
//       <form onSubmit={handleSubmit(onSubmit)} action="">
//         <div className="row">
//           <div className="col-sm-9">
//             <div className="row">
//               <div className="col-sm-4">
//                 <Input
//                   icon="title"
//                   {...register("name")}
//                   error={errors.name?.message}
//                   type="text"
//                   placeholder={`Internation`}
//                   label="Topic Name"
//                 />
//               </div>
//               <div className="col-sm-4">
//                 <Input
//                   icon="title"
//                   {...register("topicSlug")}
//                   error={errors.name?.message}
//                   type="text"
//                   placeholder={`internation`}
//                   label="Topic Slug"
//                 />
//               </div>
//               {/* details */}
//               <div className="col-sm-6">
//                 <Label className="mt-3" label={`Topic Details `} />
//                 <Controller
//                   name="details"
//                   control={control}
//                   defaultValue=""
//                   render={({ field }) => (
//                     <ReactQuill
//                       {...field}
//                       theme="snow"
//                       className="bg-white"
//                       onChange={(content) => field.onChange(content)}
//                     />
//                   )}
//                 />
//               </div>
//               <div className="col-sm-4">
//                 <Controller
//                   name="parentCategory"
//                   control={control}
//                   render={({ field }) => (
//                     <Select
//                       {...field}
//                       isClearable
//                       isMulti
//                       options={transformedCategory}
//                       placeholder="Select Parent Category"
//                       label="Select Parent Category"
//                     />
//                   )}
//                 />
//               </div>
//               <BrandButton
//                 type="submit"
//                 // title={`${!loading ? "Login" : "Loading...."}`}
//                 title={`Save Change`}
//                 className="my-5"
//               />
//             </div>
//           </div>
//         </div>
//       </form>
//     </div>
//   );
// }

// export default TopicForm;

import { useState, useEffect } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import { useMutation, useQuery } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { useForm, Controller } from "react-hook-form";
import { useQuill } from "react-quilljs"; // ✅ Changed
import "quill/dist/quill.snow.css"; // ✅ Added
import Label from "../../ChildComponents/Label";
import Input from "../../ChildComponents/Input";
import BrandButton from "../../ChildComponents/BrandButton";
import ImageUpload from "../../ChildComponents/ImageUpload";
import Select from "../../ChildComponents/Select";

// validationSchema
import { Rolechema } from "../validation/roleValidation";

// api
import { useGetCategory } from "../../store/api/categoryApi";
import { useCreateTopic, useUpdateTopic } from "../../store/api/topicApi";

function TopicForm({ data, editId, onSuccessCreated }) {
  const updateTopic = useUpdateTopic(editId?._id);
  const [loading, setLoading] = useState(false);
  const [edited, setEdited] = useState(editId ? true : false);
  const [topicDetails, setTopicDetails] = useState(""); // ✅ State for editor content

  // ✅ Setup Quill editor
  const { quill, quillRef } = useQuill();

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    control,
    watch,
    setValue,
  } = useForm({
    resolver: yupResolver(Rolechema),
  });

  const getCategory = useGetCategory();
  const {
    data: categoryData,
    isLoading: isRoleLoading,
    error: roleError,
  } = useQuery({ queryKey: "category", queryFn: getCategory });

  const transformedCategory = categoryData?.categorys?.map((i) => ({
    label: i.name,
    value: i._id,
  }));

  // ✅ Handle Quill text changes
  useEffect(() => {
    if (quill) {
      quill.on("text-change", () => {
        const content = quill.root.innerHTML;
        setTopicDetails(content);
        setValue("details", content);
      });
    }
  }, [quill, setValue]);

  // ✅ Load edit data
  useEffect(() => {
    if (editId) {
      reset({
        name: editId?.name || "",
        topicSlug: editId?.topicSlug || "",
        details: editId?.details || "",
        parentCategory:
          editId?.parentCategory?.map((cat) => ({
            label: cat?.name,
            value: cat?._id,
          })) || [],
      });

      // ✅ Load content into Quill
      if (quill && editId?.details) {
        quill.clipboard.dangerouslyPasteHTML(editId.details);
      }

      setEdited(true);
    } else {
      // ✅ Clear form when not editing
      reset({
        name: "",
        topicSlug: "",
        details: "",
        parentCategory: [],
      });

      // ✅ Clear Quill
      if (quill) {
        quill.setText("");
      }

      setEdited(false);
    }
  }, [editId, reset, quill]);

  const createTopic = useCreateTopic();

  const mutation = useMutation({
    mutationFn: (data) => {
      return editId ? updateTopic(data) : createTopic(data);
    },
    onSuccess: (data) => {
      setLoading(false);
      toast.success("Created Successfully");
      reset();

      // ✅ Clear Quill after success
      if (quill) {
        quill.setText("");
      }

      onSuccessCreated(1);
    },
    onError: (error) => {
      toast.error(error.message);
      setLoading(false);
    },
  });

  const onSubmit = (formData) => {
    setLoading(true);
    try {
      mutation.mutate({
        name: formData?.name,
        topicSlug: formData?.topicSlug,
        details: topicDetails || formData?.details, // ✅ Use state
        parentCategory:
          formData?.parentCategory?.map((item) => item.value) || [],
      });
    } catch (error) {
      setLoading(false);
      console.error("Caught error in handleSubmit:", error.message);
      toast.error(error.message);
    }
  };

  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)} action="">
        <div className="row">
          <div className="col-sm-9">
            <div className="row">
              <div className="col-sm-4">
                <Input
                  icon="title"
                  {...register("name")}
                  error={errors.name?.message}
                  type="text"
                  placeholder={`International`}
                  label="Topic Name"
                />
              </div>
              <div className="col-sm-4">
                <Input
                  icon="title"
                  {...register("topicSlug")}
                  error={errors.name?.message}
                  type="text"
                  placeholder={`international`}
                  label="Topic Slug"
                />
              </div>

              {/* Topic Details */}
              <div className="col-sm-6">
                <Label className="mt-3" label={`Topic Details`} />
                {/* ✅ Replace ReactQuill with useQuill */}
                <div style={{ minHeight: "200px" }}>
                  <div ref={quillRef} />
                </div>
                {errors.details && (
                  <p className="text-danger mt-2">{errors.details.message}</p>
                )}
              </div>

              <div className="col-sm-4">
                <Controller
                  name="parentCategory"
                  control={control}
                  render={({ field }) => (
                    <Select
                      {...field}
                      isClearable
                      isMulti
                      options={transformedCategory}
                      placeholder="Select Parent Category"
                      label="Select Parent Category"
                    />
                  )}
                />
              </div>

              <BrandButton
                type="submit"
                title={loading ? "Saving..." : "Save Change"}
                className="my-5"
                disabled={loading}
              />
            </div>
          </div>
        </div>
      </form>
    </div>
  );
}

export default TopicForm;
